// source: pbtypes/tools/telemetry_api/telemetry_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_tools_cloud_api_data_access_pb = require('../../../pbtypes/tools/cloud_api/data_access_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_data_access_pb);
goog.exportSymbol('proto.telemetry_api.CloudJSONRequest', null, global);
goog.exportSymbol('proto.telemetry_api.CloudJSONResponse', null, global);
goog.exportSymbol('proto.telemetry_api.GetTelemetryRequest', null, global);
goog.exportSymbol('proto.telemetry_api.TelemetryApiWebsocketError', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.telemetry_api.TelemetryApiWebsocketError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.telemetry_api.TelemetryApiWebsocketError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.telemetry_api.TelemetryApiWebsocketError.displayName = 'proto.telemetry_api.TelemetryApiWebsocketError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.telemetry_api.CloudJSONRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.telemetry_api.CloudJSONRequest.repeatedFields_, null);
};
goog.inherits(proto.telemetry_api.CloudJSONRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.telemetry_api.CloudJSONRequest.displayName = 'proto.telemetry_api.CloudJSONRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.telemetry_api.GetTelemetryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.telemetry_api.GetTelemetryRequest.repeatedFields_, null);
};
goog.inherits(proto.telemetry_api.GetTelemetryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.telemetry_api.GetTelemetryRequest.displayName = 'proto.telemetry_api.GetTelemetryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.telemetry_api.CloudJSONResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.telemetry_api.CloudJSONResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.telemetry_api.CloudJSONResponse.displayName = 'proto.telemetry_api.CloudJSONResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.telemetry_api.TelemetryApiWebsocketError.prototype.toObject = function(opt_includeInstance) {
  return proto.telemetry_api.TelemetryApiWebsocketError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetry_api.TelemetryApiWebsocketError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telemetry_api.TelemetryApiWebsocketError.toObject = function(includeInstance, msg) {
  var f, obj = {
code: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetry_api.TelemetryApiWebsocketError}
 */
proto.telemetry_api.TelemetryApiWebsocketError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.telemetry_api.TelemetryApiWebsocketError;
  return proto.telemetry_api.TelemetryApiWebsocketError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetry_api.TelemetryApiWebsocketError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetry_api.TelemetryApiWebsocketError}
 */
proto.telemetry_api.TelemetryApiWebsocketError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.telemetry_api.TelemetryApiWebsocketError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.telemetry_api.TelemetryApiWebsocketError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetry_api.TelemetryApiWebsocketError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telemetry_api.TelemetryApiWebsocketError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.telemetry_api.TelemetryApiWebsocketError.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.telemetry_api.TelemetryApiWebsocketError} returns this
 */
proto.telemetry_api.TelemetryApiWebsocketError.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.telemetry_api.CloudJSONRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.telemetry_api.CloudJSONRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.telemetry_api.CloudJSONRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetry_api.CloudJSONRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telemetry_api.CloudJSONRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
runlogUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
credentials: (f = msg.getCredentials()) && pbtypes_tools_cloud_api_data_access_pb.StsTemporaryCredentials.toObject(includeInstance, f),
channelsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetry_api.CloudJSONRequest}
 */
proto.telemetry_api.CloudJSONRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.telemetry_api.CloudJSONRequest;
  return proto.telemetry_api.CloudJSONRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetry_api.CloudJSONRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetry_api.CloudJSONRequest}
 */
proto.telemetry_api.CloudJSONRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRunlogUuid(value);
      break;
    case 2:
      var value = new pbtypes_tools_cloud_api_data_access_pb.StsTemporaryCredentials;
      reader.readMessage(value,pbtypes_tools_cloud_api_data_access_pb.StsTemporaryCredentials.deserializeBinaryFromReader);
      msg.setCredentials(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addChannels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.telemetry_api.CloudJSONRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.telemetry_api.CloudJSONRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetry_api.CloudJSONRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telemetry_api.CloudJSONRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRunlogUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCredentials();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_tools_cloud_api_data_access_pb.StsTemporaryCredentials.serializeBinaryToWriter
    );
  }
  f = message.getChannelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string runlog_uuid = 1;
 * @return {string}
 */
proto.telemetry_api.CloudJSONRequest.prototype.getRunlogUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.telemetry_api.CloudJSONRequest} returns this
 */
proto.telemetry_api.CloudJSONRequest.prototype.setRunlogUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional cloud_api.StsTemporaryCredentials credentials = 2;
 * @return {?proto.cloud_api.StsTemporaryCredentials}
 */
proto.telemetry_api.CloudJSONRequest.prototype.getCredentials = function() {
  return /** @type{?proto.cloud_api.StsTemporaryCredentials} */ (
    jspb.Message.getWrapperField(this, pbtypes_tools_cloud_api_data_access_pb.StsTemporaryCredentials, 2));
};


/**
 * @param {?proto.cloud_api.StsTemporaryCredentials|undefined} value
 * @return {!proto.telemetry_api.CloudJSONRequest} returns this
*/
proto.telemetry_api.CloudJSONRequest.prototype.setCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.telemetry_api.CloudJSONRequest} returns this
 */
proto.telemetry_api.CloudJSONRequest.prototype.clearCredentials = function() {
  return this.setCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.telemetry_api.CloudJSONRequest.prototype.hasCredentials = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string channels = 3;
 * @return {!Array<string>}
 */
proto.telemetry_api.CloudJSONRequest.prototype.getChannelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.telemetry_api.CloudJSONRequest} returns this
 */
proto.telemetry_api.CloudJSONRequest.prototype.setChannelsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.telemetry_api.CloudJSONRequest} returns this
 */
proto.telemetry_api.CloudJSONRequest.prototype.addChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telemetry_api.CloudJSONRequest} returns this
 */
proto.telemetry_api.CloudJSONRequest.prototype.clearChannelsList = function() {
  return this.setChannelsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.telemetry_api.GetTelemetryRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.telemetry_api.GetTelemetryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.telemetry_api.GetTelemetryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetry_api.GetTelemetryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telemetry_api.GetTelemetryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
flightId: jspb.Message.getFieldWithDefault(msg, 1, ""),
runlogUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
channelsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetry_api.GetTelemetryRequest}
 */
proto.telemetry_api.GetTelemetryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.telemetry_api.GetTelemetryRequest;
  return proto.telemetry_api.GetTelemetryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetry_api.GetTelemetryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetry_api.GetTelemetryRequest}
 */
proto.telemetry_api.GetTelemetryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFlightId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRunlogUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addChannels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.telemetry_api.GetTelemetryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.telemetry_api.GetTelemetryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetry_api.GetTelemetryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telemetry_api.GetTelemetryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlightId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRunlogUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChannelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string flight_id = 1;
 * @return {string}
 */
proto.telemetry_api.GetTelemetryRequest.prototype.getFlightId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.telemetry_api.GetTelemetryRequest} returns this
 */
proto.telemetry_api.GetTelemetryRequest.prototype.setFlightId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string runlog_uuid = 2;
 * @return {string}
 */
proto.telemetry_api.GetTelemetryRequest.prototype.getRunlogUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.telemetry_api.GetTelemetryRequest} returns this
 */
proto.telemetry_api.GetTelemetryRequest.prototype.setRunlogUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string channels = 3;
 * @return {!Array<string>}
 */
proto.telemetry_api.GetTelemetryRequest.prototype.getChannelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.telemetry_api.GetTelemetryRequest} returns this
 */
proto.telemetry_api.GetTelemetryRequest.prototype.setChannelsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.telemetry_api.GetTelemetryRequest} returns this
 */
proto.telemetry_api.GetTelemetryRequest.prototype.addChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telemetry_api.GetTelemetryRequest} returns this
 */
proto.telemetry_api.GetTelemetryRequest.prototype.clearChannelsList = function() {
  return this.setChannelsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.telemetry_api.CloudJSONResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.telemetry_api.CloudJSONResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetry_api.CloudJSONResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telemetry_api.CloudJSONResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
json: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetry_api.CloudJSONResponse}
 */
proto.telemetry_api.CloudJSONResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.telemetry_api.CloudJSONResponse;
  return proto.telemetry_api.CloudJSONResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetry_api.CloudJSONResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetry_api.CloudJSONResponse}
 */
proto.telemetry_api.CloudJSONResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.telemetry_api.CloudJSONResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.telemetry_api.CloudJSONResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetry_api.CloudJSONResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telemetry_api.CloudJSONResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJson();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string json = 1;
 * @return {string}
 */
proto.telemetry_api.CloudJSONResponse.prototype.getJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.telemetry_api.CloudJSONResponse} returns this
 */
proto.telemetry_api.CloudJSONResponse.prototype.setJson = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.telemetry_api);
